import PropTypes from "prop-types";
import MuiLink from "@mui/material/Link";
import MKTypography from "components/MKTypography";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

import socialsJSON from "assets/texts/socials.json";

function RenderSocials({ color }) {
  const renderIcon = socialsJSON.map((social) => {
    let socialIcon;
    if (social.text == "facebook") {
      socialIcon = <FacebookIcon fontSize="small" />;
    } else if (social.text == "instagram") {
      socialIcon = <InstagramIcon fontSize="small" />;
    } else if (social.text == "youtube") {
      socialIcon = <YouTubeIcon fontSize="small" />;
    }
    return (
      <MKTypography
        key={social.link}
        component={MuiLink}
        href={social.link}
        target="_blank"
        variant="body2"
        color={color}
        // color={"white"}
        // color={"secondary"}
        // fontWeight="regular"
      >
        {socialIcon}
      </MKTypography>
    );
  });

  return renderIcon;
}

RenderSocials.defaultProps = {
  color: "white",
};

// Typechecking props for the CenteredFooter
RenderSocials.propTypes = {
  color: PropTypes.text,
};

export default RenderSocials;
